var React = require('react');

function OpenBankingHeader (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 35V21.25M26.25 35V21.25M13.75 35V21.25","stroke":"#00E0FF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5 15L20 5L35 15M32.5 35V17.2208C28.4271 16.5818 24.2523 16.25 20 16.25C15.7477 16.25 11.5729 16.5818 7.5 17.2208V35M5 35H35","stroke":"#011642","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":1}),React.createElement("circle",{"cx":"20","cy":"11.6666","r":"1.5","stroke":"#00E0FF","strokeWidth":"2","key":2})]);
}

OpenBankingHeader.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = OpenBankingHeader;

OpenBankingHeader.default = OpenBankingHeader;
